import { AlertTriangle, CheckCircle2, Circle, Eye, Pencil, Trash2 } from "lucide-react";
import { BOOK_COLOR, fmtTime, msLabel, rowState } from "./omUtils";

export const BookTag = ({ name }) => (name ? <span className="om-book"><i style={{ background: BOOK_COLOR[name] || "#2a4d74" }}>{name.slice(0, 2)}</i>{name}</span> : <span className="om-dim">—</span>);

function Move({ d, shotNo }) {
  if (d.prev_odds == null || d.prev_odds === d.odds) return null;
  const diff = d.odds - d.prev_odds;
  return (
    <span className={`om-move ${diff > 0 ? "up" : "down"}`} title={`Was ${d.prev_odds.toFixed(2)} ${d.prev_shot ? `in screenshot #${shotNo[d.prev_shot] ?? "?"}` : "(manual)"}`} data-testid={`om-move-${d.id}`}>
      {diff > 0 ? "▲" : "▼"} {Math.abs(diff).toFixed(2)}
    </span>
  );
}

const Odds = ({ d, shotNo }) => (d
  ? <span className="om-odds"><b className={d.is_value ? "is-value" : ""} title={d.is_value ? `Value · EV ${(d.ev * 100).toFixed(1)}%` : d.label || ""}>{d.odds.toFixed(2)}</b><Move d={d} shotNo={shotNo} /></span>
  : <span className="om-odds none">—</span>);

const STATE = {
  verified: [CheckCircle2, "Verified", "ok"], pending: [AlertTriangle, "Not verified", "warn"], none: [Circle, "No odds", "none"],
};

function Status({ r, onVerify }) {
  const s = rowState(r);
  const [Icon, label, cls] = STATE[s];
  const settled = [r.over, r.under].find((d) => d?.result);
  return (
    <span className={`om-status ${cls}`} title={[r.over?.check, r.under?.check].filter(Boolean).join(" · ")}>
      <Icon size={14} />{settled ? settled.result : label}
      {s === "pending" && <button type="button" className="om-verify" onClick={() => onVerify(r)} data-testid={`om-verify-${r.key}`}>Verify</button>}
    </span>
  );
}

export function QuoteTable({ rows, showPlayer, shotNo, onOpenShot, onVerify, onEdit, onHistory, onDelete }) {
  return (
    <div className="om-tablewrap">
      <table className="om-table" data-testid="om-table">
        <thead><tr>{showPlayer && <th>PLAYER</th>}<th>MILESTONE</th><th>OVER ODDS</th><th>UNDER ODDS</th><th>BOOKMAKER</th><th>UPDATED</th><th>SOURCE (SCREENSHOT)</th><th>STATUS</th><th className="om-r">ACTIONS</th></tr></thead>
        <tbody>
          {rows.map((r) => {
            const d = r.over || r.under;
            const srcs = [...new Set([...(r.over?.screenshots || []), ...(r.under?.screenshots || [])])];
            return (
              <tr key={r.key} className={r.empty ? "is-empty" : ""} data-testid={`om-row-${r.key}`}>
                {showPlayer && <td className="om-player"><b>{r.player_name}</b><small>{r.team}</small></td>}
                <td className="om-ms">{msLabel(r)}</td>
                <td><Odds d={r.over} shotNo={shotNo} /></td>
                <td><Odds d={r.under} shotNo={shotNo} /></td>
                <td><BookTag name={r.bookmaker} /></td>
                <td className="om-time">{d ? fmtTime(d.scanned_at) : "—"}{d?.edited_by && !d.screenshot_id && <small>edited</small>}</td>
                <td>{srcs.map((s) => (
                  <button key={s} type="button" className={`om-src ${s === d?.screenshot_id ? "cur" : ""}`} onClick={() => onOpenShot(s)} data-testid={`om-src-${shotNo[s]}`}>#{shotNo[s] ?? "?"}</button>))}
                  {d && !srcs.length && <span className="om-dim">{d.screenshot_id === null && d.edited_by ? "manual" : "old"}</span>}
                  {!d && <span className="om-dim">—</span>}</td>
                <td><Status r={r} onVerify={onVerify} /></td>
                <td className="om-r">
                  <div className="om-actions">
                    <button type="button" disabled={!d} onClick={() => onHistory(r)} aria-label="Price history" data-testid={`om-history-${r.key}`}><Eye size={15} /></button>
                    <button type="button" disabled={!d} onClick={() => onEdit(r)} aria-label="Edit odds" data-testid={`om-edit-${r.key}`}><Pencil size={15} /></button>
                    <button type="button" disabled={!d} className="danger" onClick={() => onDelete(r)} aria-label="Remove milestone" data-testid={`om-delete-${r.key}`}><Trash2 size={15} /></button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {!rows.length && <p className="om-empty" data-testid="om-empty">No matching odds. Pick another game, player or market, or upload a screenshot.</p>}
    </div>
  );
}
